import { useAppSelector } from '@/hooks'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { utilityAccountsCollection } from '@/reducers/utilityAccounts'
import useApiDispatch from '@/hooks/useApiDispatch/useApiDispatch'
import { useState } from 'react'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { programsNewCollection } from '@/reducers/programsNew'

export type AccountNumberEntryProps = {
  onFinish: () => void
}

type FormValues = {
  accountNumber: string
}

const formSchema = yup.object({
  accountNumber: yup.string().required().label('Account Number'),
})

export default function useViewModel({ onFinish }: AccountNumberEntryProps) {
  const {
    utility,
    home,
    isLoading: fetchingUser,
  } = useAppSelector((state) => {
    return {
      utility: state.user?.user?.profile?.utility,
      isLoading: Boolean(state.user?.isFetchingUser),
      home: state.homes?.selectedHome,
    }
  })
  const { handleSubmit, register, formState } = useForm<FormValues>({
    resolver: yupResolver(formSchema),
  })
  const { isLoadingOrIdle: fetchingUtility, data } =
    utilityAccountsCollection.useFetch('/utilities/utility_account')
  const { apiDispatch } = useApiDispatch()
  const dispatch = useDispatch()
  const [submissionErrors, setSubmissionErrors] = useState<string | null>(null)

  const submit = handleSubmit(async ({ accountNumber }: FormValues) => {
    const response = await apiDispatch(
      utilityAccountsCollection.actions.update(
        `/utilities/utility_account/${home?.id}`,
        { account_number: accountNumber },
        { id: home?.id },
      ),
    )

    if (response.ok) {
      // Refresh MP programs collection if account number has changed -- this might affect eligibility display
      dispatch(programsNewCollection.actions.invalidate())
      onFinish()
    } else {
      setSubmissionErrors(response.error.message)
    }
  })

  const skip = () => {
    onFinish()
  }

  const accountNumber = data?.[0]?.account_number
  const isLoading = fetchingUtility || fetchingUser

  return {
    isLoading,
    accountNumber,
    submit,
    skip,
    submissionErrors,
    register,
    formState,
    utility,
  }
}
